const ANIMATION_DURATION = 0.2;
const MOVEMENT_DISTANCE = 25;

const citySuggestionsList = [
  "Ariyalur, Tamil Nadu",
  "Chengalpattu, Tamil Nadu",
  "Chennai, Tamil Nadu",
  "Coimbatore, Tamil Nadu",
  "Cuddalore, Tamil Nadu",
  "Dharmapuri, Tamil Nadu",
  "Dindigul, Tamil Nadu",
  "Erode, Tamil Nadu",
  "Kallakurichi, Tamil Nadu",
  "Kanchipuram, Tamil Nadu",
  "Kanyakumari, Tamil Nadu",
  "Karur, Tamil Nadu",
  "Krishnagiri, Tamil Nadu",
  "Madurai, Tamil Nadu",
  "Mayiladuthurai, Tamil Nadu",
  "Nagapattinam, Tamil Nadu",
  "Namakkal, Tamil Nadu",
  "Nilgiris, Tamil Nadu",
  "Perambalur, Tamil Nadu",
  "Pudukkottai, Tamil Nadu",
  "Ramanathapuram, Tamil Nadu",
  "Ranipet, Tamil Nadu",
  "Salem, Tamil Nadu",
  "Sivaganga, Tamil Nadu",
  "Tenkasi, Tamil Nadu",
  "Thanjavur, Tamil Nadu",
  "Theni, Tamil Nadu",
  "Thoothukudi, Tamil Nadu",
  "Tiruchirappalli, Tamil Nadu",
  "Tirunelveli, Tamil Nadu",
  "Tirupathur, Tamil Nadu",
  "Tiruppur, Tamil Nadu",
  "Tiruvallur, Tamil Nadu",
  "Tiruvannamalai, Tamil Nadu",
  "Tiruvarur, Tamil Nadu",
  "Vellore, Tamil Nadu",
  "Viluppuram, Tamil Nadu",
  "Virudhunagar, Tamil Nadu",
];
const MovieSuggestionsList = [
  "Vidaamuyrachi",
  "Captain Miller",
  "Ayalaan",
  "Thangalaan",
  "Viduthalai Part 2",
  "Indian 2",
  "Jigarthanda DoubleX",
  "Leo",
  "Mark Antony",
  "Lal Salaam",
  "Japan",
  "Maaveeran",
  "Vaathi",
  "Bommai Nayagi",
  "Farhana",
  "Pathu Thala",
  "Good Night",
  "Pon Ondru Kanden",
  "Kazhuvethi Moorkkan",
  "Rathnam",
  "Rebel",
  "Irugapatru",
  "Paramporul",
  "Love Today",
  "Gatta Kusthi",
  "Kaari",
  "Nitham Oru Vaanam",
  "Sembi",
  "Raayan",
  "Garudan",
  "Red Sandal Wood",
  "Deiva Machan",
  "Aalambana",
  "Chandramukhi 2",
  "Vettaiyan",
  "Kannagi",
  "Borrder",
  "Agilan",
  "Mission Chapter 1",
  "Vikram",
  "Ponniyin Selvan: Part 2",
  "Vaadivaasal",
  "Maharaja",
  "Irumbu Kai Maayavi",
  "Maveeran Kittu 2",
  "Vichithiran",
  "Kuttrame Thandanai 2",
  "RDX",
  "Narakasura",
  "Kanguva",
  "Tamilarasan",
  "Kaalaivanam",
];

export {
  ANIMATION_DURATION,
  MOVEMENT_DISTANCE,
  citySuggestionsList,
  MovieSuggestionsList,
};
